module.exports = __webpack_public_path__ + "images/mobile/missing_company.png";